<template>
    <div>
        <div class="simple-form flex col-3">
            <div class="form-group center">
                <div class="form-label">
                    <label>结算单号</label>
                </div>
                <div class="form-value">
                    <div class="value">
                        <span>{{ settleProof.innerNo || '无' }}</span>
                    </div>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>交易类型</label>
                </div>
                <div class="form-value">
                    <div class="value">
                        <span>{{ tradeTypeMap[settleProof.tradeType] }}</span>
                    </div>
                </div>
            </div>
            <div class="form-group center" v-if="settleProof.contractNo != null && settleProof.contractNo != ''">
                <div class="form-label">
                    <label>系统合同编号</label>
                </div>
                <div class="form-value">
                    <div class="value">
                        <span>{{ settleProof.contractNo }}</span>
                    </div>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>供方公司名称</label>
                </div>
                <div class="form-value">
                    <div class="value">
                        <span>{{ settleProof.sellerRealComName }}</span>
                    </div>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>供方公司编码</label>
                </div>
                <div class="form-value">
                    <div class="value">
                        <span>{{ settleProof.sellerRealComCode }}</span>
                    </div>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>供方标识</label>
                </div>
                <div class="form-value">
                    <div class="value">
                        <span>{{ settleProof.buyerInnerSellerCode }}</span>
                    </div>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>业务类型</label>
                </div>
                <div class="form-value">
                    <span>{{ settleBizTypeMap[settleProof.bizType] }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>结算金额(元)</label>
                </div>
                <div class="form-value">
                    <div class="value">
                        <span>{{ (parseFloat(settleProof.settleAmount || 0)).toFixed(2) }}</span>
                    </div>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>是否付款完成</label>
                </div>
                <div class="form-value">
                    <div class="value" v-if="settleProof.paymentFinished">是</div>
                    <div class="value" v-else>否</div>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>已申请金额(元)</label>
                </div>
                <div class="form-value">
                    <div class="value">
                        <span>{{ (parseFloat(settleProof.appliedPayAmount || 0)).toFixed(2) }}</span>
                    </div>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>已付款金额(元)</label>
                </div>
                <div class="form-value">
                    <div class="value">
                        <span>{{ (parseFloat(settleProof.paymentAmount || 0)).toFixed(2) }}</span>
                    </div>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label></label>
                </div>
                <div class="form-value">
                    <div class="value">
                        <span></span>
                    </div>
                </div>
            </div>
        </div>

        <div class="content-caption dashed" v-if="settleProof.payPhaseFlag">
            <span>付款阶段</span>
        </div>
        <el-table :data="settleProof.settlePayPhases" ref="multipleTable" border :span-method="arraySpanMethod" v-if="settleProof.payPhaseFlag">
            <el-table-column align="left" prop="phaseName" label="阶段名称" show-overflow-tooltip></el-table-column>
            <el-table-column align="center" prop="phaseType" label="阶段类型" width="150" show-overflow-tooltip>
                <template slot-scope="rows">
                    <span>{{ payPhaseTypeMap[rows.row.phaseType] }}</span>
                </template>
            </el-table-column>
            <el-table-column align="center" prop="acntPeriodStartDate" label="账期起算日" width="150" show-overflow-tooltip></el-table-column>
            <el-table-column align="right" prop="acntPeriodDays" width="150" label="账期" v-if="settleProof.acntPeriodForm == 1"></el-table-column>
            <el-table-column align="right" prop="phaseGapDays" width="150" label="当前阶段间隔天数" v-if="settleProof.acntPeriodForm == 2"></el-table-column>
            <el-table-column align="center" prop="calcBasis" label="金额计算依据" width="150" show-overflow-tooltip>
                <template slot-scope="rows">
                    <span>{{ amtCalcMethodMap[rows.row.calcBasis] }}</span>
                </template>
            </el-table-column>
            <el-table-column align="right" prop="ratio" label="付款比例(%)" width="150" show-overflow-tooltip></el-table-column>
            <el-table-column align="right" prop="amount" label="付款金额" width="150" show-overflow-tooltip></el-table-column>
            <el-table-column align="center" prop="payMethod" width="150" label="付款方式">
                <template slot-scope="rows">
                    <span>{{ payMethodMap[rows.row.payMethod] }}</span>
                </template>
            </el-table-column>
        </el-table>
        <div class="content-caption dashed">
            <span>付款单</span>
        </div>
        <div class="form-toolbar" style="text-align: left" v-if="settleProof.settleChannelId == -1 && settleProof.availableAmount > 0 && !settleProof.paymentFinished && (settleProof.pullBackNo == null || settleProof.pullBackNo == '')">
            <!-- 非阶段付款显示：阶段付款自动生成支付单 -->
            <button class="swb-btn swb-btn-small" v-if="!settleProof.payPhaseFlag" @click="applyPayOption();">申请付款</button>
        </div>
        <div class="table-layout">
            <el-table ref="multipleTable" :data="payVoucherList" border maxHeight="500" tooltip-effect="dark" style="width: 100%">
                <el-table-column prop="no" label="付款单据号" width="160px;" fixed align="center" show-overflow-tooltip></el-table-column>
                <el-table-column prop="payPhaseName" label="阶段名称" width="120px;" show-overflow-tooltip></el-table-column>
                <el-table-column prop="acntPeriodStartDate" label="账期起算日" width="120px;" show-overflow-tooltip></el-table-column>
                <el-table-column prop="outerNo" label="外部付款单据号" width="160px;" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column prop="reservedPayNo" label="付款凭证号" width="160px;" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column prop="staffLoan" label="员工借款" width="70px;" align="center" show-overflow-tooltip>
                    <template slot-scope="rows">
                        <span class="font-red" v-if="rows.row.staffLoan">是</span>
                        <span v-else>否</span>
                    </template>
                </el-table-column>
                <el-table-column prop="subject" label="付款主题" width="120px;" show-overflow-tooltip></el-table-column>
                <el-table-column prop="payWayText" label="付款途径" width="80px;" align="center"></el-table-column>
                <el-table-column prop="payResultText" label="付款形式" width="80px;">
                    <template slot-scope="rows">
                        <span>{{ payFormMap[rows.row.payForm] }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="payMethod" label="付款方式" width="80px;">
                    <template slot-scope="rows">
                        <span>{{ payMethodMap[rows.row.payMethod] }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="amount" label="付款金额(元)" width="90px;" align="right">
                    <template slot-scope="rows">
                        <span v-if="rows.row.prePayFlag">{{ (row.row.amountPre || 0).toFixed(2) }}</span>
                        <span v-else>{{ rows.row.amount }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="auditStateText" label="审核状态" width="80px;" align="center"></el-table-column>
                <el-table-column prop="payResultText" label="付款状态" width="80px;"></el-table-column>
                <el-table-column prop="createTime" label="创建日期" width="160px;" align="center"></el-table-column>
                <el-table-column prop="" label="操作">
                    <template slot-scope="rows"><!--checkActionPerm('audit', rows.row.auditorPostId) && -->
                        <a class="swb-btn-link" v-if="rows.row.auditState == 0 && rows.row.applyState != 1" @click="assignAuditor(rows.row)">指定审核岗</a>
                        <a class="swb-btn-link" v-if="rows.row.applyState == 1 && rows.row.auditState != 1 && !rows.row.discarded && rows.row.auditorPostId == userInfo.scopeEntity.postId" @click="doCheck(rows.row.id);">审核</a>
                        <a class="swb-btn-link" @click="viewPayInfo(rows.row.id);">详情</a>
                        <a class="swb-btn-link" @click="editBankAccInfo(rows.row);" v-if="!rows.row.discarded && rows.row.payResult != 1">补充银行卡</a>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pagination-layout">
            <el-pagination background :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange"
                           layout="total, sizes, prev, pager, next, jumper"></el-pagination>
        </div>
    </div>
</template>

<script>
import {Utils} from '../../app.base'
import {Vue, MsgBox, Routes} from '../../app.vues'
import {getDefaultPageSizes} from '../../app.conf'
import {checkUserActionPerm} from '../index'
import {showComActionPostSelectDlg} from '../merchant/showSelectDlg'
import {showPayVoucherSaveDlg, showBankAccInfoDlg} from './showDlg'

import userApi from '../../api/user'
import settleApi from '../../api/settle'
import finacApi from '../../api/finac'

import SwbPayVoucherInfo from '../payment/PayVoucherInfo';

Vue.regist(SwbPayVoucherInfo);

export default {
    name: 'swb-settle-payment-info',
    avlActions: '',
    avlScopes: 'retailer',
    desc: '结算付款信息',
    props: {
        proofId: {
            type: Number,
            default: null
        },
        parentPath: {
            Type: String,
            default: '/settle/proof/list/get'
        }
    },
    data: function () {
        // 校验
        let self = this;
        let amountPreCheck = function (rule, value, callback) {
            if (Utils.isTrue(self.settleProof.usePrePay)) {
                if (Utils.isNoB(value)) {
                    callback(new Error('预付金额不能为空'));
                } else {
                    if (!Utils.isMoneyStr(value)) {
                        callback(new Error('必须是金额'));
                    } else {
                        let val = parseFloat(value);
                        if (val <= 0) {
                            callback(new Error('申请金额必须大于0'));
                        } else {
                            let regex = /^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/;
                            if (regex.test(val)) {
                                let settleProof = self.settleProof || {};
                                let usableAmount = settleProof.usableAmount || 0;
                                if (val > usableAmount) {
                                    callback(new Error('该金额超过了可用的金额'));
                                } else {
                                    callback();
                                }
                            } else {
                                callback(new Error('输入的金额不能超过两位小数'));
                            }
                        }
                    }
                }
            } else {
                callback();
            }
        };
        let payAmount = function (rule, value, callback) {
            if (Utils.isNoB(value)) {
                callback(new Error('申请金额不能为空'));
            } else {
                if (!Utils.isMoneyStr(value)) {
                    callback(new Error('必须是金额'));
                } else {
                    let val = parseFloat(value);
                    if (val <= 0) {
                        callback(new Error('申请金额必须大于0'));
                    } else {
                        let regex = /^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/;
                        if (regex.test(val)) {
                            let settleProof = self.settleProof || {};
                            let settleAmount = settleProof.settleAmount || 0;
                            let appliedPayAmount = settleProof.appliedPayAmount || 0;
                            let totalPay = appliedPayAmount + val;
                            if (totalPay > settleAmount) {
                                callback(new Error('该金额超过了可以申请的金额'));
                            } else {
                                callback();
                            }
                        } else {
                            callback(new Error('输入的金额不能超过两位小数'));
                        }
                    }
                }
            }
        };
        let checkSubject = function (rule, value, callback) {
            if (Utils.isNoB(value)) {
                callback(new Error('付款主题不能为空'));
            } else {
                callback();
            }
        };
        // 返回值
        return {
            //
            pageNumber: 1,
            totalCount: 1,
            pageSize: null,
            pageSizes: getDefaultPageSizes(),
            //
            settleProof: {
                payForm: getEnumInfoWith('payForm', 'name', 'Trans').value,
                staffLoan: false
            },
            payVoucherList: [],
            prePayVouchers: [],
            userInfo: {},
            refresh: false,
            merchantTypeMap: getEnumMap('merchantType', 'value2text'),
            tradeTypeMap: getEnumMap('tradeType', 'value2text'),
            settleBizTypeMap: getEnumMap('settleBizType', 'value2text'),
            payMethodMap: getEnumMap("payMethod", "value2text"),
            payFormMap: getEnumMap("payForm", "value2text"),
            payFormList: getEnumList('payForm'),
            // 校验
            checkPay: {
                amountPre: [{
                    validator: amountPreCheck,
                    trigger: 'blur'
                }],
//                    amountPost: [{
//                        validator: amountPostCheck,
//                        trigger: 'blur'
//                    }],
//                    payAmount: [{
//                        validator: payAmount,
//                        trigger: 'blur'
//                    }],
                subject: [{
                    validator: checkSubject,
                    trigger: 'blur'
                }],
            },
            payPeriodTypeMap: getEnumMap('payPeriodType', 'value2text'),
            payPhaseTypeMap: getEnumMap('payPhaseType', 'value2text'),
            amtCalcMethodMap: getEnumMap('amtCalcMethod', 'value2text')
        }
    },
    created: function () {
        //保持pageSize的一致性
        this.pageSize = this.pageSizes.first();
        //
        this.getCurrentUserInfo();
        this.getPayVoucherList();
    },
    methods: {
        checkActionPerm: function (action, targetPostId) {
            return checkUserActionPerm(this.parentPath, action, targetPostId);
        },
        // 当前登录信息
        getCurrentUserInfo: function () {
            let self = this;
            let data = {};
            userApi.getUserInfoByContext(data, function (result) {
                if (result.type === 'info') {
                    self.userInfo = result.data;
                } else {
                    MsgBox.warning(result.message);
                }
            });
        },
        getSettleProofDetails: function (id) {
            let self = this;
            settleApi.getSettleProof(id, function (result) {
                if (result.type == 'info') {
                    //
                    let settleProof = result.data || {};
                    let appliedPayAmount = settleProof.appliedPayAmount || 0;
                    settleProof.availableAmount = parseFloat(settleProof.settleAmount) - parseFloat(appliedPayAmount);
                    let settlePayPhases = settleProof.settlePayPhases;
                    if (!Utils.isNoB(settlePayPhases) && settlePayPhases.length > 0) {
                        let preRow = null;
                        // 循环settlePayPhases
                        for (let i = 0; i < settlePayPhases.length; i++) {
                            settlePayPhases[i].rowspan = 1;
                            if (preRow == null) {
                                preRow = settlePayPhases[i];
                            } else if (preRow.phaseName == settlePayPhases[i].phaseName) {
                                preRow.rowspan++;
                                settlePayPhases[i].rowspan = 0;
                            } else {
                                preRow = settlePayPhases[i];
                            }
                        }
                    }
                    self.settleProof = Utils.merge({}, settleProof);
                } else {
                    MsgBox.warning(result.message);
                }
            })
        },
        //
        handleSizeChange: function (val) {
            let curStartIndex = (this.pageNumber - 1) * this.pageSize;
            this.pageSize = val;
            let newPageNumber = Math.max(1, Math.ceil(curStartIndex / this.pageSize));
            this.handlePageChange(newPageNumber);
        },
        handlePageChange: function (val) {
            this.pageNumber = val;
            this.getPayVoucherList();
        },
        getPayVoucherList: function () {
            let self = this;
            let postData = {};
            postData.pagination = {
                pageSize: self.pageSize,
                pageNumber: self.pageNumber
            };
            let filterItems = {};
            if (!Utils.isNoB(self.proofId)) {
                filterItems.srcVoucherType = getEnumInfoWith('srcVoucherType', 'name', 'SettleProof').value;
                filterItems.srcVoucherId = self.proofId;
            }
            //
            postData.filterItems = filterItems;
            //
            let msgBoxDlg = MsgBox.loading();
            finacApi.getPayVoucherList(postData, function (result) {
                msgBoxDlg.close();
                if (result.type == 'info') {
                    let payVoucherList = result.data.rows || [];
                    if (!Utils.isNoB(payVoucherList) && payVoucherList.length > 0) {
                        for (let i = 0; i < payVoucherList.length; i++) {
                            let payVoucher = payVoucherList[i];
                            payVoucher.amount = payVoucher.amount.toFixed(2);
                            //
                            let payWayInfo = getEnumInfoWith('payWay', 'value', payVoucher.payWay);
                            if (payWayInfo != null) {
                                payVoucher.payWayText = payWayInfo.text;
                            }
                            // 审核状态处理
                            if (payVoucher.applyState == 0) {
                                payVoucher.auditStateText = '未申请';
                            } else if (payVoucher.applyState == 1 && payVoucher.auditState == 0) {
                                payVoucher.auditStateText = '待审核';
                            } else if (payVoucher.applyState == 2 && payVoucher.auditState == 1) {
                                payVoucher.auditStateText = '审核通过';
                            } else if (payVoucher.applyState == 2 && payVoucher.auditState == -1) {
                                payVoucher.auditStateText = '审核未通过';
                            }

                            //
                            let resultStateInfo = getEnumInfoWith('resultState', 'value', payVoucher.payResult);
                            if (resultStateInfo != null) {
                                if (resultStateInfo.name == 'Failure') {
                                    payVoucher.payResultText = '失败';
                                } else if (resultStateInfo.name == 'Success') {
                                    payVoucher.payResultText = '成功';
                                } else {
                                    if (payVoucher.discarded && !payVoucher.deleted) {
                                        payVoucher.payResultText = '拒绝付款';
                                    } else {
                                        payVoucher.payResultText = '待付款';
                                    }
                                }
                            }
                        }
                    }
                    self.payVoucherList = Utils.merge([], payVoucherList);
                    //
                    let pagination = result.data.pagination;
                    self.totalCount = pagination.totalCount;
                    self.pageNumber = pagination.pageNumber;
                    self.pageSize = pagination.pageSize;
                    //
                    if (!Utils.isNoB(self.proofId)) {
                        self.getSettleProofDetails(self.proofId);
                    }
                } else {
                    MsgBox.warning(result.message);
                }
            })
        },
        // 申请催款
        applyPayOption: function () {
            let self = this;
            let settleProof = self.settleProof;
            let params = {
                proofId: settleProof.id,
                contractId: settleProof.contractId,
                sellerRealComId: settleProof.sellerRealComId,
                buyerRealComId: settleProof.buyerRealComId,
                availableAmount: settleProof.availableAmount
            };
            showPayVoucherSaveDlg(params, function (payInfo, theDlg) {
                let payVoucher = {};
                payVoucher.manualFlag = true;
                payVoucher.srcVoucherType = getEnumInfoWith('srcVoucherType', 'name', 'SettleProof').value;
                payVoucher.srcVoucherId = settleProof.id;
                payVoucher.srcVoucherSysNo = settleProof.no;
                payVoucher.srcVoucherInnerNo = settleProof.innerNo;
                //
                payVoucher.payerRealId = settleProof.buyerRealId;
                payVoucher.payerRealComId = settleProof.buyerRealComId;
                payVoucher.payerRealComCode = settleProof.buyerRealComCode;
                payVoucher.payerRealComName = settleProof.buyerRealComName;
                //
                payVoucher.amountPost = payInfo.amountPost;
                payVoucher.amount = payInfo.payAmount;
                //
                payVoucher.rcverRealId = settleProof.sellerRealId;
                payVoucher.rcverRealComId = settleProof.sellerRealComId;
                payVoucher.rcverRealComCode = settleProof.sellerRealComCode;
                payVoucher.rcverRealComName = settleProof.sellerRealComName;
                //
                payVoucher.rcvCardNo = payInfo.rcvCardNo;
                payVoucher.rcvBankName = payInfo.rcvBankName;
                payVoucher.rcvAcctName = payInfo.rcvAcctName;
                payVoucher.rcvAcctNo = payInfo.rcvAcctNo;
                //
                payVoucher.payCardNo = payInfo.payCardNo;
                payVoucher.payBankName = payInfo.payBankName;
                payVoucher.payAcctName = payInfo.payAcctName;
                payVoucher.payAcctNo = payInfo.payAcctNo;
                //
                payVoucher.subject = payInfo.subject;
                payVoucher.payForm = payInfo.payForm;
                payVoucher.payWay = payInfo.payWay;
                payVoucher.payMethod = payInfo.payMethod;
                //
                payVoucher.memo = payInfo.memo;
                payVoucher.applyDesc = payInfo.applyDesc;
                //
                let hintMsg = payInfo.hintMsg;
                if (!Utils.isNoB(hintMsg)) {
                    self.$confirm(hintMsg, '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(function () {
                        //
                        let lastMsgBoxDlg = MsgBox.loading();
                        finacApi.savePayVoucher(payVoucher, function (result) {
                            if (result.type == 'info') {
                                theDlg.close();
                                setTimeout(function () {
                                    lastMsgBoxDlg.close();
                                    MsgBox.success('申请成功');
                                    self.refresh = true;
                                    self.getPayVoucherList();
                                }, 3000);
                            } else {
                                MsgBox.warning(result.message);
                                lastMsgBoxDlg.close();
                            }
                        });
                    }).catch(function () {
                    });
                } else {
                    //
                    let lastMsgBoxDlg = MsgBox.loading();
                    finacApi.savePayVoucher(payVoucher, function (result) {
                        if (result.type == 'info') {
                            theDlg.close();
                            setTimeout(function () {
                                lastMsgBoxDlg.close();
                                MsgBox.success('申请成功');
                                self.refresh = true;
                                self.getPayVoucherList();
                            }, 3000);
                        } else {
                            MsgBox.warning(result.message);
                            lastMsgBoxDlg.close();
                        }
                    });
                }
            });
        },
        // 指定审核人
        assignAuditor: function (row) {
            let self = this;
            //
            showComActionPostSelectDlg({
                title: '指定审核岗',
                rescUrl: self.parentPath,
                action: 'audit',
                initPostId: row.auditorPostId,
                applyDesc: row.applyDesc
            }, function (resultData) {
                resultData = resultData || {};
                if (resultData.postId == null) {
                    MsgBox.warning('请选择审核岗位');
                    return false;
                } else if (!Utils.isNoB(resultData.applyDesc) && resultData.applyDesc.length > 250) {
                    MsgBox.warning('附加描述最多不能超过250个字');
                    return false;
                }
                //
                let postData = {
                    id: row.id,
                    //
                    auditorPostId: resultData.postId,
                    auditorPostName: resultData.actionPostName,
                    //
                    applyDesc: resultData.applyDesc
                };
                //
                let msgBoxDlg = MsgBox.loading();
                finacApi.assignPayVoucherAuditorInfo(postData, function (result) {
                    msgBoxDlg.close();
                    if (result.type == 'info') {
                        self.getPayVoucherList();
                        MsgBox.success('操作成功');
                    } else {
                        MsgBox.warning(result.message);
                    }
                });

            }, this);
        },
        // 详情
        viewPayInfo: function (payVoucherId) {
            let self = this;
            Vue.$showDialog({
                title: '付款单 - 查看',
                showCloseBtn: true,
                width: 900,
                height: 800,
                okVisible: false,
                cancelText: '关闭',
                template: '<div>' +
                    '<swb-pay-voucher-info :voucherId="voucherId" :optionFlag="optionFlag" ref="swb_pay_voucher_info"></swb-pay-voucher-info>' +
                    '</div>',
                data: {
                    voucherId: null,
                    optionFlag: 'chaKan'
                },
                methods: {},
                okClicked: function () {
                },
                lifecycle: {
                    created: function () {
                        this.voucherId = payVoucherId;
                    }
                }
            })
        },
        // 补充银行卡信息
        editBankAccInfo: function (row) {
            let self = this;
            let settleProof = self.settleProof;
            row.contractId = settleProof.contractId;
            showBankAccInfoDlg(row, function (bankAccInfo, theDlg) {
                bankAccInfo.id = row.id;
                let hintMsg = bankAccInfo.hintMsg;
                if (!Utils.isNoB(hintMsg)) {
                    self.$confirm(hintMsg, '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(function () {
                        //
                        let msgBoxDlg = MsgBox.loading();
                        finacApi.updatePayVoucherBankAccInfo(bankAccInfo, function (result) {
                            msgBoxDlg.close();
                            if (result.type == 'info') {
                                theDlg.close();
                                self.getPayVoucherList();
                                MsgBox.success('操作成功');
                            } else {
                                MsgBox.warning(result.message);
                            }
                        });
                    }).catch(function () {
                    });
                } else {
                    let msgBoxDlg = MsgBox.loading();
                    finacApi.updatePayVoucherBankAccInfo(bankAccInfo, function (result) {
                        msgBoxDlg.close();
                        if (result.type == 'info') {
                            theDlg.close();
                            self.getPayVoucherList();
                            MsgBox.success('操作成功');
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }
            });
        },
        // 审核操作
        doCheck: function (payVoucherId) {
            let self = this;
            Vue.$showDialog({
                title: '付款单 - 审核',
                showCloseBtn: true,
                width: 900,
                height: 800,
                template: '<div>' +
                    '<swb-pay-voucher-info :voucherId="voucherId" :optionFlag="optionFlag" ref="swb_pay_voucher_info"></swb-pay-voucher-info>' +
                    '</div>',
                data: {
                    voucherId: null,
                    optionFlag: 'shenHe'
                },
                methods: {},
                okClicked: function () {
                    let result = this.$refs.swb_pay_voucher_info.getDlgResult() || {};
                    // 成功执行
                    if (result.type == 'info') {
                        // 处理你的信息添加赋值
                        let postData = result.data;
                        //
                        let msgBoxDlg = MsgBox.loading();
                        finacApi.auditPayVoucher(postData, function (result) {
                            msgBoxDlg.close();
                            if (result.type == 'info') {
                                self.getPayVoucherList();
                                MsgBox.success('操作成功');
                            } else {
                                MsgBox.warning(result.message);
                            }
                        });
                        return true;
                    } else {
                        MsgBox.warning(result.message);
                    }
                    return false;
                },
                lifecycle: {
                    created: function () {
                        this.voucherId = payVoucherId;
                    }
                }
            })
        },
        arraySpanMethod({row, column, rowIndex, columnIndex}) {
            if (columnIndex === 0 || columnIndex === 1 || columnIndex === 2 || columnIndex === 3) {
                if (row.rowspan == 0) {
                    return [0, 0];
                } else {
                    return [row.rowspan, 1];
                }
            }
        },
        getDlgResult: function () {
            let result = {};
            result.type = 'info';
            result.data = this.refresh;
            return result;
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/compo/settle/SettlePaymentInfo.vue